import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { IoArrowBack } from "react-icons/io5";
import SUCCESSIMAGE from "../assets/img/success.png";
import { useNavigate } from "react-router-dom";
import { errorMessage, sendFormFunction } from "../data/services/form_contract";
import { removeMask } from "../utils/remove_mask";

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20000;
  border-radius: 8px;
`;

const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 6px solid #005ca9;
  border-top: 6px solid transparent;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const Dialog = styled.div`
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  width: 70%;
  height: auto;

  h2 {
    align-self: self-start;
    text-align: start;
    color: #005ca9;
    font-size: 15pt;
  }
`;

const DialogContent = styled.div`
  width: 80%;
  display: flex;
  flex-direction: column;
  max-height: 400px;
  overflow-y: auto;

  h4 {
    font-size: 15pt;
    color: #005ca9;
  }

  img {
    width: 100px;
    align-self: center;
    margin-top: 80px;
  }

  div {
    display: flex;
    align-items: baseline;
    margin-bottom: 8px;

    strong {
      font-weight: 700;
      font-size: 12pt;
      margin-right: 5px;
    }

    span {
      font-size: 12pt;
      color: black;
    }
  }
`;

const WrapButtons = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-around;
  margin-top: 25px;
`;

const BackButton = styled.button`
  background-color: transparent;
  padding: 12px;
  width: 200px;
  border-radius: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  border-color: #ff5742;
  border-width: 1px;
  color: #005ca9;
  font-size: 12pt;
  cursor: pointer;
`;

const SaveButton = styled.button`
  background-color: #ff5742;
  padding: 12px;
  width: 200px;
  border-radius: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  border-color: #ff5742;
  border-width: 1px;
  color: white;
  font-size: 12pt;
  font-weight: 600;
  cursor: pointer;
`;

type DialogComponentProps = {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  name: string;
  cpf: string;
  email: string;
  phone: string;
  bithday: string;
  CEP: string;
  address: string;
  number: string;
  neighborhood: string;
  city: string;
  cityCode: string;
  state: string;
  unidade: string;
  compliment: string;
  dependents: {
    nome: string;
    telefone: string;
    cpf: string;
    email: string;
    relationship: string;
  }[];
};

export default function DialogComponent({
  isOpen,
  onClose,
  title,
  name,
  cpf,
  email,
  phone,
  bithday,
  CEP,
  address,
  number,
  neighborhood,
  city,
  cityCode,
  state,
  unidade,
  compliment,
  dependents,
}: DialogComponentProps) {
  const [isSaved, setIsSaved] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  if (!isOpen) return null;


  const handleSaveButton = async () => {
    setIsLoading(true);

    try {
      const dependentsMapped = dependents.map((dep) => ({
        Nome_dependente: dep.nome,
        Telefone_dependente: removeMask(dep.telefone),
        CPF_dependente: removeMask(dep.cpf),
        Email_dependente: dep.email,
        Grau_parentesco: 30,
      }));

      const response = await sendFormFunction(
        cpf,
        name,
        phone,
        CEP,
        address,
        email,
        neighborhood,
        number,
        "a",
        parseInt(cityCode),
        31,
        parseInt(unidade),
        new Date().toISOString(),
        parseInt(localStorage.getItem("enterpriseID")!),
        parseInt(localStorage.getItem("categoryID")!),
        3,
        parseInt(localStorage.getItem("contractNumber")!),
        parseInt(localStorage.getItem("contracdID")!),
        dependentsMapped
      );

      if (response.holderId) {
        setIsSaved(true);
      } else {
        console.error("Erro ao salvar:", response.errorMessage);
        alert("Erro ao salvar: " + response.errorMessage);
      }
    } catch (error) {
      console.error("Erro inesperado ao salvar:", error);
      alert("Ocorreu um erro ao tentar salvar os dados.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleContinueAndClose = () => {
    window.location.reload();
  };

  

  return (
    
    <DialogOverlay>
      <Dialog>
        {isLoading && (
          <LoadingOverlay>
            <Spinner />
          </LoadingOverlay>
        )}
        {isSaved ? (
          <>
            <DialogContent>
              <img src={SUCCESSIMAGE} />
              <h4>Cadastro salvo com sucesso!</h4>
              <WrapButtons>
                <BackButton onClick={handleContinueAndClose}>
                  Continuar e fechar
                </BackButton>
                <SaveButton onClick={onClose}>Salvar +</SaveButton>
              </WrapButtons>
            </DialogContent>
          </>
        ) : (
          <>
            <h2>{title}</h2>
            <DialogContent>
              <div>
                <strong>Nome Completo:</strong> <span>{name}</span>
              </div>
              <div>
                <strong>CPF:</strong> <span>{cpf}</span>
              </div>
              <div>
                <strong>Telefone:</strong> <span>{phone}</span>
              </div>
              {/* <div>
                <strong>Data de Nascimento:</strong> <span>{bithday}</span>
              </div> */}
              <div>
                <strong>CEP:</strong> <span>{CEP}</span>
              </div>
              <div>
                <strong>Endereço:</strong> <span>{address}</span>
              </div>
              <div>
                <strong>Número:</strong> <span>{number}</span>
              </div>
              <div>
                <strong>Bairro:</strong> <span>{neighborhood}</span>
              </div>
              <div>
                <strong>Cidade:</strong> <span>{city}</span>
              </div>
              {/* <div>
                <strong>Complemento:</strong> <span>{compliment}</span>
              </div> */}

              {dependents.length > 0 && (
                <>
                  <h4 style={{ marginTop: "20px" }}>Dependentes</h4>

                  {dependents.map((dep, index) => (
                    <div
                      key={index}
                      style={{
                        marginBottom: "15px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div>
                        <strong>Nome:</strong> <span>{dep.nome}</span>
                      </div>
                      <div>
                        <strong>CPF:</strong> <span>{dep.cpf}</span>
                      </div>
                      <div>
                        <strong>Email:</strong> <span>{dep.email}</span>
                      </div>
                      <div>
                        <strong>Telefone:</strong> <span>{dep.telefone}</span>
                      </div>
                      {/* <div>
                        <strong>Parentesco:</strong>{" "}
                        <span>{dep.relationship}</span>
                      </div> */}
                    </div>
                  ))}
                </>
              )}
            </DialogContent>
            <WrapButtons>
              <BackButton onClick={onClose}>
                <IoArrowBack size={24} /> Voltar e Corrigir
              </BackButton>
              <SaveButton onClick={handleSaveButton}>Salvar</SaveButton>
            </WrapButtons>
          </>
        )}
      </Dialog>
    </DialogOverlay>
  );
}
